export default {
  baseURL: 'https://wanfang-api.huashuyunai.com/index.php?s=/api/', // 接口域名
  applyUrl: 'https://wanfang-h5.huashuyunai.com/#/', // 邀请h5域名
  REQUEST_SECRET: '123456'
}
